/* eslint-disable */
<template>
  <div class="container-fluid no-padding">
    <div class="row bg-primary-dark">
      <div class="col-md-8 mb-2 mt-2 align-middle">
        <h4>Üretimler</h4>
      </div>
      <div class="col-md-4 mb-2 mt-2">
        <router-link class="btn btn-more-radius btn-success float-right" to="/uretim/urun-olustur">Yeni Ürün Oluştur</router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-wait for="uretimler-loading">
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Üretimler yükleniyor...</p>
            </div>
          </template>
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th style="width: 2%;" scope="col">#</th>
                <th style="width: 8%;" scope="col">BAŞLANGIÇ</th>
                <th style="width: 15%;" scope="col">ÜRETİM</th>
                <th style="width: 15%;" scope="col">HEDEF ÜRÜN</th>
                <th style="width: 5%;" scope="col">ÜRETİM ADEDİ</th>
                <th style="width: 8%;" scope="col">DURUM</th>
                <th style="width: 8%;" scope="col">BİTİŞ</th>
                <th style="width: 12%;" scope="col">OLUŞTURAN</th>
                <th scope="col">KOMUTLAR</th>
              </tr>
            </thead>
            <tbody class="tbody-margin">
              <template v-for="(uretim, index) in uretimler">
                <tr :key="'trow-first-' + uretim.URETIM_ID">
                  <td class="align-middle text-center">
                    <div class="custom-control custom-checkbox text-center">
                      <input type="checkbox" class="custom-control-input" :value="uretim.URETIM_ID"
                        v-model="selectedUretimler" :id="'all-prods-' + index">
                      <label class="custom-control-label" v-bind:for="'all-prods-' + index"></label>
                    </div>
                  </td>
                  <td class="align-middle">{{uretim.URETIM_STARTDATE_FORMATTED}}</td>
                  <td class="align-middle">
                    <div class="justify-content-between text-truncate">
                      <p class="my-0 font-semi-bold">{{uretim.URUN_NAME}}</p>
                      <small class="text-muted">{{uretim.URUN_DESCRIPTION}}</small>
                    </div>
									</td>
                  <td class="align-middle">
                    <div class="justify-content-between">
                      <p class="my-0 font-semi-bold">{{uretim.MALZEME_NAME}}</p>
                      <small class="text-muted">{{uretim.MALZEME_CODE}}</small>
                    </div>
                  </td>
                  <td class="align-middle">{{uretim.URETIM_QUANTITY}}</td>
                  <td class="align-middle text-center">
										<button class="btn btn-more-radius" :class="parseUretimStatusAsClass(uretim.URETIM_STATUS)">{{parseUretimStatusAsView(uretim.URETIM_STATUS)}}</button>
									</td>
                  <td class="align-middle">{{uretim.URETIM_FINISHDATE_FORMATTED}}</td>
                  <td class="align-middle">{{uretim.PERSONEL_NAME}}</td>
                  <td class="align-middle text-center">
										<button type="button" v-if="uretim.URETIM_STATUS != 1" class="btn btn-danger btn-more-radius" 
											@click="endProduction(uretim.URETIM_ID, 1)">Üretimi Tamamla</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-wait>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'UrunlerPage',
  components: {
  },
  data () {
    return {
      uretimler: [],
			selectedUretimler: [],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 3000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    getProductions() {
      this.$wait.start('urunler-loading')
      axios.post('/api/stok/tum-uretimler?sessionid=' + this.getSessionId + '&searchFilter=')
      .then(response => {
        console.log(response.data)
        this.uretimler = response.data
        this.$wait.end('urunler-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('urunler-loading')
      })
		},
		endProduction(uretimId, type) {
      this.$wait.start('urunler-loading')
			axios.post('/api/stok/uretim-bitir?sessionid=' 
				+ this.getSessionId + '&uretimId=' + uretimId + "&newStatus=" + type)
      .then(response => {
				this.$toasted.success('Üretim tamamlandı ve hedef ürün stoku güncellendi.', this.toastOptions)
        this.getProductions()
      })
      .catch(error => {
				this.$toasted.success('Üretim tamamlanamadı. Durum: ' + error.ErrorMessage, this.toastOptions)
        console.error(error) 
			})
			
			this.$wait.end('urunler-loading')
		},
		parseUretimStatusAsView(status) {
			if(status == 0)
				return 'AKTİF'
			if(status == 1)
				return 'TAMAMLANDI'
			if(status == 2)
				return 'İPTAL EDİLDİ'
		},
		parseUretimStatusAsClass(status) {
			if(status == 0)
				return 'btn-primary'
			if(status == 1)
				return 'btn-success'
			if(status == 2)
				return 'btn-danger'
		}
  },
  mounted() {
    this.getProductions()
  }
}
</script>

<style scoped>

  .font-semi-bold {
    font-weight: 500;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/UretimlerPage.vue